'use client'

import { cn } from '@mntn-dev/ui-utilities'

import { getSvgGradient } from './gradients/map.ts'
import type { SvgGradientName } from './gradients/types.ts'
import { Icon, type IconProps } from './icon.tsx'
import { iconSizeClassMap } from './types/maps.ts'

export type GradientIconProps = IconProps & {
  gradient: SvgGradientName
}

export const GradientIcon = ({
  className,
  gradient,
  size,
  ...iconProps
}: GradientIconProps) => {
  const { id, component: GradientComponent } = getSvgGradient(gradient)

  return (
    <>
      <svg
        className={cn(
          'absolute',
          size !== 'inherit' && iconSizeClassMap[size],
          className
        )}
      >
        <defs>
          <GradientComponent />
        </defs>
      </svg>
      <Icon
        {...iconProps}
        size={size}
        style={{ fill: `url(#${id})` }}
        className={className}
      />
    </>
  )
}
